<template>
	<div class="news">
		<div class="news_header">
			<div class="w1200 flex">
				<router-link to="/" class="header_logo"><img :src="public.bottom_logo" class="block" /></router-link>
				<div class="header_nav f18px">
					<ul>
						<li class="header_nav_list"><router-link to="/" class="cl_white">首页</router-link></li>
						<li class="header_nav_list"><router-link to="/study" class="cl_white">趣学习</router-link></li>
						<li class="header_nav_list"><router-link to="/career" class="cl_white">生涯规划</router-link></li>
						<li class="header_nav_list"><router-link to="/wish" class="cl_white">志愿填报</router-link></li>
						<li class="header_nav_list on"><router-link to="/news_list" class="cl_white">高中资讯</router-link></li>
					</ul>
				</div>
				<div class="news_header_r" v-if="token == null">
					<router-link to="/" class="cl_white f16px">登录</router-link>
					&nbsp;&nbsp;&nbsp;&nbsp;<router-link to="/logon" class="cl_white f16px">注册</router-link>
				</div>
				<div class="news_header_r" v-else>
					<router-link to="/personal" class="flex cl_white news_header_info">
						<img :src="myInfo.avatar" class="radius mar10" />
						<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) < 0">{{myInfo.real_name}}</span>
						<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) < 0">{{myInfo.name}}</span>
						<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) > 0">{{myInfo.wx_nickname}}</span>
					</router-link>
				</div>
			</div>
		</div>
		<div class="news_banner">
			<router-link :to="news_banner.url"><img :src="news_banner.pic" class="block" /></router-link>
		</div>
		<div class="news_cont w1200 flex">
			<div class="news_cont_l">
				<div class="news_cont_l_title cl_white">
					<h3 class="f20px">高中资讯</h3>
					<p class="mat5">High school information</p>
				</div>
				<div class="news_cont_nav">
					<div class="news_nav_list" v-for="(item,index) in nav" :key="index" :class="{'on':item.id==navCur}">
						<div class="news_nav_list_title flex f20px cl_dark" @click="navCheck(item.id,index)">
							<div class="news_nav_list_title_l flex">
								<img :src="item.icon" class="mar10" />
								<span>{{item.name}}</span>
							</div>
							<img src="../../../static/select_btm.png" class="news_nav_list_title_r" />
						</div>
						<ul class="news_nav_list_cont f18px cl_gray">
							<li class="news_nav_list_item" v-for="(item,index) in item.senior_info_two_cate" :key="index" :class="{'on':item.id==listCur}" @click="listCheck(item.id,index)">{{item.name}}</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="news_cont_r">
				<div class="news_cont_r_title flex">
					<h3 class="f22px">{{navName}}</h3>
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  高中资讯
						  >  {{navName}}  >  {{listName}}</p>
					</div>
				</div>
				<div class="news_list_cont">
					<div class="news_list" v-for="item in list" :key="item.id">
						<router-link :to="{ path: '/news_details', query: { id: item.id}}" class="news_list_l"><img :src="item.pic" class="block" /></router-link>
						<div class="news_list_r">
							<router-link :to="{ path: '/news_details', query: { id: item.id}}" class="f20px cl_dark clip">{{item.name}}</router-link>
							<h4 class="f16px cl_gray mat20">{{item.intro}}</h4>
							<div class="news_list_btm flex">
								<span class="cl_gray">更新时间：{{item.add_time}}</span>
								<router-link :to="{ path: '/news_details', query: { id: item.id}}" class="cl_white tc news_list_btm_r">阅读</router-link>
							</div>
						</div>
					</div>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray">共 {{total}} 条记录 页次：{{currentPage}}/{{Math.ceil(total/pageSize)}}页   {{pageSize}}条/页</div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next, jumper" @size-change="handleSizeChange" 
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
			</div>
		</div>
		<vfooter @child-event="parentEvent"></vfooter>
	</div>
</template>

<script>
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'news_list',
		components: {
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				public: {}, //公共部分
				news_banner: { //广告
					url: "",
					pic: require("../../../static/news_banner.png"),
				},
				token: localStorage.getItem("token"),
				myInfo: {}, //个人信息
				navCur: 0, //默认选中
				navName: "",
				listCur: 0,
				navIndex: 0,
				listIndex: 0,
				listName: "",
				nav: [], //分类
				list: [], //列表
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
			}
		},
		created() {
			
		},
		mounted() {
			if (localStorage.getItem("token")) {
				this.getMyinfo();
			}
			this.getNav();
		},
		methods: {
			parentEvent (data) {
				this.public = data;
			},
			//获取用户信息
			getMyinfo () {
				var that = this;
				that.$get("/api/user/get_user_info",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					that.myInfo = res.data;
				});
			},
			//获取分类
			getNav () {
				var that = this;
				that.$get("/api/seniorinfo/get_senior_info_cate_list",{})
				.then(res => {
					that.nav = res.data;
					that.navCur = that.nav[0].id;
					that.listCur = that.nav[0].senior_info_two_cate[0].id;
					that.navName = that.nav[0].name;
					that.listName = that.nav[0].senior_info_two_cate[0].name;
					that.getList();
				});
			},
			//获取列表
			getList () {
				var that = this;
				that.$get("/api/seniorinfo/get_senior_info_list",{
					senior_info_cate_id: that.listCur,
					page: that.currentPage,
					limit: that.pageSize,
				})
				.then(res => {
					that.list = res.data.data;
					that.total = res.data.total;
				});
			},
			navCheck (e,index) {
				if (this.navCur == e) {
					this.navCur = "";
				} else {
					this.navCur = e;
					this.navIndex = index;
				}
			},
			listCheck (e,index) {
				this.listCur = e;
				this.listIndex = index;
				this.navName = this.nav[this.navIndex].name;
				this.listName = this.nav[this.navIndex].senior_info_two_cate[this.listIndex].name;
				this.getList();
			},
			handleSizeChange: function (size) {
				this.pageSize = size;
				console.log(this.pageSize)  //每页下拉显示数据
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
				console.log(this.currentPage)  //点击第几页
			},
		},
	}
</script>

<style>
</style>
